import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Chinese ID generator following Single Responsibility Principle
 */
export class CnGenerator extends BaseGenerator {
  generate(options = {}) {
    const { birthDate = null, gender = null } = options;

    // Area code (6 digits) - using common codes
    const areaCodes = ['110101', '310101', '440101', '500101', '120101'];
    const areaCode = areaCodes[this.randomInt(0, areaCodes.length - 1)];

    // Birth date (8 digits)
    let birthDateStr;
    if (birthDate) {
      const date = new Date(birthDate);
      const year = date.getFullYear();
      const month = this.padZero(date.getMonth() + 1, 2);
      const day = this.padZero(date.getDate(), 2);
      birthDateStr = year + month + day;
    } else {
      const year = this.randomInt(1950, 2005);
      const month = this.padZero(this.randomInt(1, 12), 2);
      const day = this.padZero(this.randomInt(1, 28), 2);
      birthDateStr = year + month + day;
    }

    // Sequence code (3 digits) - last digit indicates gender
    let sequenceCode = this.randomDigits(2);
    let genderDigit;
    
    if (gender === 'male') {
      genderDigit = this.randomInt(0, 4) * 2 + 1; // Odd for male
    } else if (gender === 'female') {
      genderDigit = this.randomInt(0, 4) * 2; // Even for female
    } else {
      genderDigit = this.randomInt(0, 9);
    }
    
    sequenceCode += genderDigit;

    // Calculate check digit
    const partial = areaCode + birthDateStr + sequenceCode;
    const checkDigit = this.calculateCheckDigit(partial);

    return partial + checkDigit;
  }

  calculateCheckDigit(digits) {
    const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const checksums = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    
    let sum = 0;
    for (let i = 0; i < 17; i++) {
      sum += parseInt(digits[i]) * weights[i];
    }

    return checksums[sum % 11];
  }
}